import { Box } from '@mui/material';
import { pdvScale } from './pdvScale';

// Decoração do fundo do tema Azul — mesma filosofia da LoginTechDecoration/
// PDVBasicoDecoration/PDVOceanDecoration/PDVGrafiteDecoration (100% CSS/MUI,
// sem imagem): formas diagonais discretas nos cantos (duas camadas de cada
// lado, mais marcadas que as outras decorações), grade de pontos esmaecendo
// nas bordas (mask) e duas formas rotacionadas com anéis de box-shadow, uma
// pra cada lado. O gradiente de base (três brilhos radiais azulados +
// diagonal claro) fica em PDVThemes.ts (colors.backgroundImage do tema
// 'azul') — aqui só as camadas que dependem de mask-image/box-shadow, que
// um background-image comum não consegue expressar. Todos os tamanhos usam
// pdvScale (mesma escala global do PDV) em vez de clamp()/vw + @media
// próprios, pra não voltar ao problema de cada elemento escalando numa
// curva diferente.
export const PDVAzulDecoration: React.FC = () => (
  <Box sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    {/* Formas diagonais nos cantos superior-esquerdo/inferior-direito —
        duas camadas de cada lado, uma mais forte encostada no canto e outra
        mais fraca logo depois. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        background: `
          linear-gradient(135deg, rgba(0, 139, 210, 0.14) 0%, rgba(0, 139, 210, 0.08) 9%, transparent 9.2%),
          linear-gradient(135deg, transparent 0%, transparent 7%, rgba(0, 139, 210, 0.055) 7.1%, rgba(0, 139, 210, 0.055) 11%, transparent 11.2%),
          linear-gradient(315deg, rgba(0, 139, 210, 0.16) 0%, rgba(0, 139, 210, 0.07) 10%, transparent 10.2%),
          linear-gradient(315deg, transparent 0%, transparent 8%, rgba(0, 139, 210, 0.05) 8.1%, rgba(0, 139, 210, 0.05) 13%, transparent 13.2%)
        `,
      }}
    />

    {/* Grade de pontos — esmaece nas bordas (mask), diagonal como as formas acima. */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        opacity: 0.55,
        backgroundImage: 'radial-gradient(circle, rgba(0, 139, 210, 0.30) 1.6px, transparent 1.9px)',
        backgroundSize: '20px 20px',
        maskImage: 'linear-gradient(135deg, #000 0%, transparent 21%, transparent 79%, #000 100%)',
        WebkitMaskImage: 'linear-gradient(135deg, #000 0%, transparent 21%, transparent 79%, #000 100%)',
      }}
    />

    {/* Forma esquerda — quadrado arredondado a 45°, sangrando pra fora da
        borda esquerda, com dois anéis concêntricos via box-shadow. */}
    <Box
      sx={{
        position: 'absolute',
        left: pdvScale(-360),
        top: '14%',
        width: pdvScale(461),
        height: pdvScale(461),
        border: `${pdvScale(1.5)} solid rgba(0, 139, 210, 0.13)`,
        borderRadius: pdvScale(90),
        transform: 'rotate(45deg)',
        boxShadow: `
          ${pdvScale(55)} ${pdvScale(55)} 0 rgba(0, 139, 210, 0.025),
          ${pdvScale(110)} ${pdvScale(110)} 0 rgba(0, 139, 210, 0.018)
        `,
      }}
    />

    {/* Forma direita — espelhada, sangrando pra fora da borda direita. */}
    <Box
      sx={{
        position: 'absolute',
        right: pdvScale(-360),
        bottom: '-4%',
        width: pdvScale(461),
        height: pdvScale(461),
        border: `${pdvScale(1.5)} solid rgba(0, 139, 210, 0.13)`,
        borderRadius: pdvScale(90),
        transform: 'rotate(45deg)',
        boxShadow: `
          ${pdvScale(-55)} ${pdvScale(-55)} 0 rgba(0, 139, 210, 0.025),
          ${pdvScale(-110)} ${pdvScale(-110)} 0 rgba(0, 139, 210, 0.018)
        `,
      }}
    />
  </Box>
);
